import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Sign_out extends PureComponent {
  render() {
    return (
      <div className="row" id="sign_out">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Authentication Sign Out</h2>
              <p>
                Users can Sign In on multiple devices but can only have one
                Session on an individual device/browser. If a user Signs In on a
                laptop and a mobile phone they will have two active Session IDs,
                one for each device. Each Session ID has the usual
                rolling/absolute expiry rules.
              </p>
              <p>
                The timeout function removes the user's Session from the
                database blocking them from all access.
              </p>
              <p>
                The Nexoid API offers two methods of Signing Out. The first
                signs out the current Session leaving other devices Signed In
                (Example 1). The second signs out all open Sessions belonging to
                that user (Example 2).
              </p>
              <p>
                In the example of a single Session Sign Out, you can expect a
                200 response if that Session cannot be found or has already been
                Signed Out.
              </p>

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Authentication Sign Out Example</h2>
              <h3>Example 1</h3>
              <p>This example will sign out a single session.</p>
              <p>Example Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/authentication/sign_out
                <div>
                  <br />
                </div>
                <div>Request Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Example Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Response Body:</div>
                <div>&#123; &#125;</div>
              </div>
              <h3>Example 2</h3>
              <p>This example will sign a user out of all sessions.</p>
              <p>Example Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/authentication/sign_out_all
                <div>
                  <br />
                </div>
                <div>Request Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Example Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Response Body:</div>
                <div>&#123; &#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Sign_out;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Sign_out.js